import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Wrapper from '../../components/templates/SchoolWrapper';
import Title from '../../components/Service/SchoolOverview/Title';
import Tutors from '../../components/Service/SchoolOverview/Tutors';
import Classes from '../../components/Service/SchoolOverview/Classes';
import Courses from '../../components/Service/SchoolOverview/Courses';

const SchoolOverviewMain = () => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <>
        <Head>
          <title>{t('title.school.overview')}</title>
          <meta
            name="description"
            content={t('service.school.overview.intro')}
          />
        </Head>
        <div className="school-main-content">
          <Title />
          <Tutors />
          <Classes />
          <Courses />
        </div>
      </>
    </Wrapper>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default SchoolOverviewMain;
